module.exports = {
      id: "boom500 index-usage",
      viewBox: "0 0 33 32",
      url: __webpack_public_path__ + "sprite-83ccd1.smartcharts.svg#boom500 index-usage",
      toString: function () {
        return this.url;
      }
    }